import { ArrowUpRight } from "lucide-react";
import { ROTORS, BUY_URL } from "@/data/products";
import { Reveal } from "@/components/Reveal";

const RotorPanel = ({ rotor }) => (
  <a
    href={BUY_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`rotor-card-${rotor.id}`}
    className="group relative block w-full overflow-hidden border border-white/10 hover:border-ebc-red transition-colors duration-500 min-h-[70vh]"
  >
    <img
      src={rotor.image}
      alt={rotor.name}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-[1200ms] ease-out group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_35%,rgba(0,0,0,0.65)_100%)]" />

    <div className="relative z-10 h-full min-h-[70vh] flex flex-col justify-end p-7 sm:p-10">
      <div className="flex items-center justify-between mb-4">
        <span className="font-mono text-xs tracking-[0.25em] text-ebc-red">[{rotor.num}]</span>
        <ArrowUpRight className="w-6 h-6 text-white/60 group-hover:text-ebc-red transition-colors duration-300" />
      </div>
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-300 mb-2">
        {rotor.tag}
      </p>
      <h3 className="font-display uppercase leading-none tracking-tight text-white text-5xl sm:text-7xl">
        {rotor.name}
      </h3>
      <p className="mt-4 max-w-md text-sm sm:text-base text-neutral-300 leading-relaxed">
        {rotor.desc}
      </p>
    </div>
  </a>
);

export const RotorsSection = () => {
  return (
    <section id="rotors" data-testid="rotors-section" className="relative bg-ebc-surface py-20 sm:py-28">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        {/* Sticky left */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-ebc-red mb-4">
                / 02 — Rotors
              </p>
              <h2 className="font-display uppercase leading-[0.85] tracking-tight text-white text-5xl sm:text-7xl">
                Spin.
                <br />
                <span className="text-stroke-red">Stop.</span>
                <br />
                Repeat.
              </h2>
              <p className="mt-6 max-w-sm text-sm sm:text-base text-neutral-400 leading-relaxed">
                British-made in German mill-rolled precision stainless steel. Two profiles,
                one obsession — control under heat.
              </p>
              <a
                href={BUY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="rotors-buy-now"
                className="group mt-8 inline-flex items-center gap-3 bg-ebc-red hover:bg-ebc-redhover text-white font-mono text-xs uppercase tracking-[0.15em] px-6 py-4 transition-colors duration-300"
              >
                Explore Rotors
                <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </Reveal>
          </div>
        </div>

        {/* Right image stack */}
        <div className="lg:col-span-8 flex flex-col gap-4 sm:gap-6">
          {ROTORS.map((rotor, i) => (
            <Reveal key={rotor.id} delay={i * 0.08}>
              <RotorPanel rotor={rotor} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
